// outline (not box-shadow) so the indicator survives forced-colors / Windows High Contrast
export const FOCUS_RING_COLOR = "#185CFB";

export const focusRingSx = {
  outline: `3px solid ${FOCUS_RING_COLOR}`,
  outlineOffset: "2px",
};

// for controls over the Header gradient, where the blue ring has no contrast
export const focusRingOnDarkSx = {
  outline: "3px solid #FFFFFF",
  outlineOffset: "2px",
};

// for controls clipped by an overflow:hidden ancestor, where an outer ring would be cut off
export const focusRingInsetSx = {
  outline: `3px solid ${FOCUS_RING_COLOR}`,
  outlineOffset: "-3px",
};
